export default "__VITE_ASSET__U5Xv$mmc__"